import CalendarUI, {CalendarUIConfig} from './CalendarUI';

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.event-calendar').forEach((element) => {
		const observeElements = element.getAttribute('data-calendar-observe-elements');
		const calendarViewTrigger = element.getAttribute('data-calendar-view-trigger');

		const dateFilterFieldArea = document.querySelector('.dateFilterFieldArea');
		const dateRangeRadio = dateFilterFieldArea.querySelector<HTMLInputElement>('input[value="range"]');
		const dateFilterLI = dateRangeRadio.closest('li');
		const dateRangeStart = dateFilterLI.querySelector<HTMLInputElement>('input[data-subfield="from"]');
		const dateRangeEnd = dateFilterLI.querySelector<HTMLInputElement>('input[data-subfield="to"]');

		new CalendarUI(new CalendarUIConfig({
			elem: element.querySelector<HTMLElement>('.event-calendar__calendar'),
			observeElements: Array.from(document.querySelectorAll<HTMLElement>(observeElements)),
			calendarViewTrigger: document.querySelector<HTMLElement>(calendarViewTrigger),

			dateRangeRadio,
			dateRangeStart,
			dateRangeEnd,
		}));
	});
});
